import { Link } from '@tanstack/react-router';

export function FinancialMfaNotice() {
  return (
    <div
      role="alert"
      className="surface space-y-2 border border-[var(--color-warn)] bg-[var(--color-warn-muted)] p-4"
    >
      <p className="font-medium">Admin MFA check required</p>
      <p className="text-[var(--color-ink-muted)] text-[var(--text-sm)]">
        Financial entries require a current admin MFA check. Open{' '}
        <Link to="/admin/security" className="font-medium text-[var(--color-accent)] underline">
          Security
        </Link>{' '}
        to send and verify an email code before creating charges or recording payments.
      </p>
    </div>
  );
}
